var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoofing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9L10 0L14 3.6V1H17V6.3L20 9H17L10 2.7L3 9H0ZM7 17V11H13V17H7ZM9 15H11V13H9V15Z",
    fill: "#7F599D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofing);
export default __webpack_public_path__ + "static/media/roofing.a6e8c5ed5f7e9e556e7a29014c06abdb.svg";
export { ForwardRef as ReactComponent };